module.exports = __webpack_public_path__ + "static/media/MoonLight.aa28266d.svg";